<footer class="relative text-dark-gray2  px-[4%] sm:px-[6.3%] py-6 lg:py-14 3xl:py-16">
    <video  class="absolute inset-0 w-full h-full object-cover z-0" loop muted autoplay oncanplay="this.play()"
        onloadedmetadata="this.muted = true">
        <source src="assets/hero/waves1.mp4" type="video/mp4">
    </video>
    <div class="absolute inset-0 bg-video-overlay opacity-80 z-10"></div>
    <div class="relative z-20 flex flex-col lg:flex-row gap-6 lg:gap-4 2xl:gap-6 3xl:gap-8 text-sm lg:text-xs 3xl:text-sm">
        <div class="p-6 3xl:p-8 flex flex-col items-center justify-between bg-card-gray rounded-md 3xl:rounded-lg text-center lg:text-left">
            <div class="self-center lg:self-start mb-32 lg:mb-0">
                <img height="39" width="96" loading="lazy" class="w-24 h-auto 3xl:w-[122px] object-cover" src="assets/footer/black-logo.png" alt="Whizz_Logo">
            </div>
            <div>
                <hr class="border-light-gray2">
                <p class="mb-3 3xl:mb-4 mt-4 3xl:mt-[18px] text-wrap lg:text-nowrap">&copy; 2024 Whizz Systems Inc. All
                    rights reserved.</p>
                <hr class="border-light-gray2">
                <div class="flex justify-center lg:justify-start items-center gap-6 3xl:gap-8">
                    <div *ngFor="let item of privacyTerms"
                        class="cursor-pointer hover:text-teal1 underline underline-offset-auto mt-9 3xl:mt-11 transition-all duration-300 ease-in-out">
                        <a routerLink="item.link">{{item.label}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-6 lg:gap-3 3xl:gap-8 bg-card-gray text-dark-gray2 p-6 3xl:p-8 rounded-md 3xl:rounded-lg text-center md:text-left">
            <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-2">
                <h3 class="text-base lg:text-sm 3xl:text-base mb-4 3xl:mb-6 font-medium 3xl:font-semibold">Get in touch
                </h3>

                <h4 class="font-semibold mb-1">North America <br> Silicon Valley HQ</h4>
                <p>3240 Scott Blvd. <br> Santa Clara, CA 95051</p>

                <h4 class="font-semibold mt-4 3xl:mt-6 mb-1">Global Office</h4>
                <p>Lot 8, SMI Park Phase 2 <br class="block lg:hidden 3xl:block"> Jalan Hi-Tech 4 Sambungan <br
                        class="block lg:hidden 3xl:block"> Kulim Hi-Tech Park
                    09000 <br class="block lg:hidden 3xl:block"> Kulim, KEDHA Malaysia</p>

                <h4 class="font-semibold mt-4 3xl:mt-6 mb-1">Contact:</h4>
                <div *ngFor="let item of contacts">
                    <a class="underline cursor-pointer hover:text-teal1 transition-all duration-300 ease-in-out"
                        routerLink="item.link">{{item.label}}</a>
                </div>
            </div>
            <!-- Services -->
            <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-2">
                <h3 class="text-base lg:text-sm 3xl:text-base mb-4 lg:mb-6 3xl:mb-8 font-medium 3xl:font-semibold">
                    Services</h3>
                <div *ngFor="let item of services">
                    <a class="mb-3 3xl:mb-4 inline-block cursor-pointer hover:text-teal1 transition-all duration-300 ease-in-out"
                        [routerLink]="item.link">{{item.label}}</a>
                </div>
            </div>
            <!-- Blog -->
            <div class="col-span-12  md:col-span-6 lg:col-span-2 2xl:col-span-1">
                <h3 class="text-base lg:text-sm 3xl:text-base mb-4 lg:mb-6 3xl:mb-8 font-medium 3xl:font-semibold">Blog
                </h3>
                <div *ngFor="let item of blog">
                    <a class="mb-3 3xl:mb-4 inline-block cursor-pointer hover:text-teal1 text-nowrap transition-all duration-300 ease-in-out"
                        [routerLink]="item.link">{{item.label}}</a>
                </div>
            </div>
            <!-- Social media -->
            <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-2">
                <h3
                    class="text-base lg:text-sm 3xl:text-base mb-4 lg:mb-6 3xl:mb-8 font-medium 3xl:font-semibold text-nowrap">
                    Social Media</h3>
                    <div *ngFor="let item of socailMedia">
                        <a class="mb-3 3xl:mb-4 flex items-center cursor-pointer hover:text-teal1 transition-all duration-300 ease-in-out"
                           [href]="item.link" target="_blank">
                           
                          <ng-container [ngSwitch]="item.label">
                            <svg *ngSwitchCase="'LinkedIn'" xmlns="http://www.w3.org/2000/svg"
                                 class="w-5 3xl:w-6 mr-4 fill-current"
                                 viewBox="0 0 448 512" height="16" width="14">
                              <path
                                d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                            </svg>
                      
                            <svg *ngSwitchCase="'Youtube'" xmlns="http://www.w3.org/2000/svg"
                                 class="w-5 3xl:w-6 mr-4 fill-current"
                                 viewBox="0 0 576 512" height="16" width="14">
                              <path
                                d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
                            </svg>
                          </ng-container>
                      
                          {{ item.label }}
                        </a>
                      </div>
                      
            </div>
            <div class="col-span-12 md:col-span-12 lg:col-span-4 2xl:col-span-5 grid justify-center lg:justify-end items-center lg:mr-6 2xl:mr-14 3xl:mr-16 ">
                <div
                    class="w-64 lg:w-[13rem] 2xl:w-64 3xl:w-80 p-6 lg:p-4 2xl:p-6 3xl:p-8 bg-white border border-light-gray1 rounded-md 3xl:rounded-lg text-left">
                    <h1 class="text-2xl lg:text-xl 2xl:text-2xl 3xl:text-3xl font-bold">Subscribe to our newsletter!</h1>
                    <p class="mt-3 3xl:mt-5 mb-5 3xl:mb-8 font-light text-base lg:text-xs 2xl:text-base 3xl:text-xl">Get updates
                        on the <br> latest news & insights</p>
                    <app-animated-button routerLink="/" heading="Subscribe" size="medium" bg="teal-bg"></app-animated-button>
                </div>
            </div>
        </div>
    </div>
</footer>